import { useEffect } from 'react';
import { executeJriverShortcut, handleJriverKeyDown } from '../keyboard/jriverShortcuts';

/**
 * Global JRiver-style shortcuts (Ctrl+P/L/N/S/M/F/T, volume, seek).
 * Mount once in AppLayout.
 */
export default function useJriverKeyboardShortcuts({ onFind } = {}) {
  useEffect(() => {
    const handlers = { onFind };

    const onShortcutEvent = (e) => {
      const action = e?.detail?.action;
      if (!action) return;
      executeJriverShortcut(action, handlers);
    };

    const onKey = (e) => {
      handleJriverKeyDown(e, handlers);
    };

    window.addEventListener('maestro:jriver-shortcut', onShortcutEvent);
    window.addEventListener('keydown', onKey, true);
    return () => {
      window.removeEventListener('maestro:jriver-shortcut', onShortcutEvent);
      window.removeEventListener('keydown', onKey, true);
    };
  }, [onFind]);
}
